// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  projectId: __t.string().name("project_id"),
  orgId: __t.string().name("org_id"),
  parentId: __t.option(__t.string()).name("parent_id"),
  authorUserId: __t.string().name("author_user_id"),
  authorName: __t.string().name("author_name"),
  authorAvatar: __t.string().name("author_avatar"),
  body: __t.string(),
  timeUs: __t.option(__t.f64()).name("time_us"),
  clipId: __t.option(__t.string()).name("clip_id"),
  createdAt: __t.timestamp().name("created_at"),
  editedAt: __t.option(__t.timestamp()).name("edited_at"),
  resolved: __t.bool(),
  resolvedByName: __t.string().name("resolved_by_name"),
  endUs: __t.option(__t.f64()).name("end_us"),
  drawing: __t.string(),
  jobId: __t.string().name("job_id"),
  versionId: __t.string().name("version_id"),
  scopeId: __t.string().name("scope_id"),
  linkId: __t.string().name("link_id"),
  assetRound: __t.u32().name("asset_round"),
});
